// extracted by mini-css-extract-plugin
export var content = "_8f-3";
export var list = "_8f-4";
export var settingsContent = "_8f-7";
export var settingsPanel = "_8f-8";
export var state = "_8f-6";
export var triggerBadge = "_8f-2";
export var triggerButton = "_8f-1";
export var triggerShell = "_8f-0";
export var unreadDot = "_8f-5";